<div>
  <div class="mx-auto" *ngIf="loadingZonas">
    <div class="d-flex justify-content-center">
      <strong>{{ inputMessageModal }}</strong>
    </div>
    <div class="d-flex justify-content-center">
      <strong>Espere un momento mientras se carga la información ... 
        <div class="spinner-border" role="status"></div>
      </strong>
    </div>
  </div>
  <!-- <table datatable [dtOptions]="dtOptions2" [dtTrigger]="dtTriggerZona" class="table table-striped table-responsive"> -->
  <!--<table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTriggerZona" class="table-striped table-responsive">-->
  <div *ngIf="!loadingZonas">
    <div class="row">
      <div class="col-9">
      </div>
      <div class="col-3">
        <input type="text" [ngModel]="searchT" [class]="'form-control'" placeholder="Buscar..."
          (keyup)="changeSearch($event)">
      </div>
    </div>
    <table datatable [dtTrigger]="dtTriggerZona" class="table table-striped table-responsive">
      <thead>
        <tr>
          <th>Acciones</th>
          <th>Nombre Zona</th>
          <th>Comuna</th>
          <th>Estado</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let zona of zonasMantenedor | paginate: {itemsPerPage : 10, currentPage: pageActualZona}">
          <td class="td-centered">
            <span (click)="onCreateZona(zonaModal,'Editar', zona)" [ngbTooltip]="'Editar'">
              <img class="icon-table" [src]="'assets/icons/pencil.svg'" />
            </span>
            <span (click)="openDeleteModalZona(confirmationModal, zona)" [ngbTooltip]="'Eliminar'">
              <img [src]="'assets/icons/trashcan.svg'" />
            </span>
          </td>
          <td class="td-centered">{{zona.descripcion}}</td>
          <td class="td-centered">{{zona.comuna}}</td>
          <td class="td-centered">{{getEstadoLabel(zona.status)}}</td>
        </tr>
      </tbody>
    </table>
    <pagination-controls (pageChange)="pageActualZona = $event" class="pagination"></pagination-controls>
  </div>
</div>

<ng-template #confirmationModal let-modal>
  <app-confirmation-modal [modal]="modal" [tittle]="confirmationModalTittle" [message]="confirmationModalMessage"
    [hasComment]="confirmationModalHasComment" [hasOptions]="confirmationModalHasOptions"
    [isCommentObligatory]="confirmationModalisCommentObligatory" [optionLabel]="confirmationModalOptionLabel"
    [options]="confirmationModalOptions" (accept)="confirmationModalAccept($event.comment, $event.option)">
  </app-confirmation-modal>
</ng-template>

<ng-template #zonaModal let-modal>
  <app-zona-modal [modalZona]="modal" [mode]="creationMode" [zona]="zonaSelected" (createEdit)="refreshZonasCreateOrUpdate($event)">
  </app-zona-modal>
</ng-template>
